import { Button, Drawer, Space } from "antd";
import { AiOutlineClose } from "react-icons/ai";
import DateLine from "../../../components/shared/DateLine";
import formatMoney from "../../../utils/formatMoney";

export default function RevenueDetails({
  isVisible,
  setShowDetails,
  selected,
  startDate,
  endDate,
}: any) {
  const filtered = selected?.list?.filter(
    (item: any) => item?.sales_value !== 0
  );


  return (
    <Drawer
      title={
        <div className="flex items-center">
          <span className="mr-2 text-lg">{selected?.name} Revenue :</span>
          <DateLine startDate={startDate} endDate={endDate} />
        </div>
      }
      placement={"right"}
      width={800}
      onClose={() => setShowDetails(!isVisible)}
      visible={isVisible}
      closable={false}
      extra={
        <Space>
          <Button
            type="default"
            color="#E50000"
            onClick={() => setShowDetails(!isVisible)}
            danger
          >
            <AiOutlineClose />
          </Button>
        </Space>
      }
    >
      <div className="font-toyota">
        <div className="flex py-1 border-b border-gray-300">
          <div className="mr-2 w-8 text-center font-bold">S/N.</div>
          <div className="flex justify-between items-center flex-1">
            <div className="flex items-center">
              <div className="w-48 truncate font-bold">Customer</div>
              <div className="truncate font-bold mx-1 w-20 ml-2">Vehicle</div>
              <div className="truncate font-bold mx-1 w-20">Invoice</div>
              <div className="truncate font-bold mx-1 w-20">WIP</div>
            </div>
            <div className="font-bold">Amount</div>
          </div>
        </div>
        {filtered?.map((item: any, index: number) => (
          <div className="flex py-1 border-b border-gray-300">
            <div className="mr-2 w-8 text-center">{index + 1}.</div>
            <div className="flex justify-between items-center flex-1">
              <div className="flex items-center">
                <div className="w-48 truncate ">
                  {item.customer === 0
                    ? item?.company_details[0]?.name
                    : item?.customer_details[0]?.name}
                </div>
                <div className="mx-1 w-20 ml-2">{item.registration}</div>
                <div className="mx-1 w-20">{item.invoice}</div>
                <div className="mx-1 w-20">{item.wip}</div>
              </div>
              <div className="">{formatMoney(item?.sales_value)}</div>
            </div>
          </div>
        ))}
        <div className="flex justify-between items-start border-t-2 border-b-2 py-2">
          <div className=""></div>
          <div className="font-bold">{formatMoney(selected?.net)}</div>
        </div>
      </div>
    </Drawer>
  );
}
